import React, { useEffect } from "react";
import useGetMovies from "../custom-hooks/useGetMovies";
import Carousel from "./Carousel";
import Text from "../components/Text";
import { upcoming } from "../constants";
import { settings } from "../constants/slider";
import "../assets/styles/components/MovieList.scss";

import Movie from "./Movie";
import Error from "./Error";
import Loader from "./Loader";

const Upcoming = () => {
  const { movies, loading, error, getMovies } = useGetMovies(`${upcoming()}`);

  useEffect(() => {
    getMovies();
  }, []);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <Error />
      ) : (
        <>
          <Text text="Upcoming" />
          <Carousel settings={settings}>
            {movies.map((movie) => (
              <Movie key={movie.id} data={movie} />
            ))}
          </Carousel>
        </>
      )}
    </div>
  );
};

export default Upcoming;
